import React from 'react';
import {useDispatch} from 'react-redux';
import {StyledAddExpenseButton} from './StyledAddExpenseButton';
import {StarsIcon} from '../../../../icons';
import {useCompanySetting} from '../../../../hooks';
import {companySettingsConstants, expensesPlanConstants} from '../../../../constants';
import {agentActions} from '../../../../state/actions/agent.actions';
import {expenseActions} from '../../../../state/actions/expense.actions';

const AddExpenseButton = ({
  children,
  ...rest
}) => {

  const dispatch = useDispatch();

  const expensesPlan = useCompanySetting(companySettingsConstants.EXPENSES_PLAN);

  const isAdvancedPlan = expensesPlan === expensesPlanConstants.ADVANCED;

  const handleOpenAgentChat = () => dispatch(agentActions.openAgentChat());

  const handleOpenAddExpenseModal = () => dispatch(expenseActions.openAddExpenseModal());

  const handleOnClick = () => {
    const key = expensesPlan ?? expensesPlanConstants.BASIC;
    ({
      [expensesPlanConstants.ADVANCED]: handleOpenAgentChat,
      [expensesPlanConstants.BASIC]: handleOpenAddExpenseModal,
    })[key]?.();
  };

  return (
    <StyledAddExpenseButton
      icon={isAdvancedPlan && <StarsIcon /> }
      onClick={handleOnClick}
      type='primary'
      {...rest}
    >
      {children}
    </StyledAddExpenseButton>
  );
}

export default AddExpenseButton;
